"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowPopup = exports.WindowPopupInstance = void 0;
class WindowPopupInstance {
    constructor() {
        Object.defineProperty(this, "handler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "popupWindow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "popupCheckInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    open(url, options) {
        this.popupWindow = window.open(url, undefined, this.getFeatures(options.width, options.height));
        this.startMonitoringPopup();
    }
    onMessage(callback) {
        this.handler = (event) => callback(event.data);
        window.addEventListener('message', this.handler);
    }
    startMonitoringPopup() {
        if (this.popupCheckInterval)
            clearInterval(this.popupCheckInterval);
        this.popupCheckInterval = window.setInterval(() => {
            if (!this.popupWindow || this.popupWindow.closed) {
                this.cleanup();
            }
        }, 500);
    }
    cleanup() {
        if (this.handler) {
            window.removeEventListener('message', this.handler);
            this.handler = undefined;
        }
        if (this.popupCheckInterval) {
            clearInterval(this.popupCheckInterval);
            this.popupCheckInterval = undefined;
        }
        this.popupWindow = null;
    }
    getFeatures(popupWidth, popupHeight) {
        const windowTop = window.screenTop || window.screenY;
        const windowLeft = window.screenLeft || window.screenX;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;
        const systemZoom = windowWidth / window.screen.availWidth;
        const top = (windowHeight - popupHeight) / 2 / systemZoom + windowTop;
        const left = (windowLeft - popupWidth) / 2 / systemZoom + windowLeft;
        return [
            `top=${top}`,
            `left=${left}`,
            `width=${popupWidth}`,
            `height=${popupHeight}`,
            'scrollbars=yes',
            'menubar=false',
            'toolbar=false',
        ].join(',');
    }
    close() {
        if (this.popupWindow && !this.popupWindow.closed) {
            this.popupWindow.close();
        }
        this.cleanup();
    }
}
exports.WindowPopupInstance = WindowPopupInstance;
exports.WindowPopup = new WindowPopupInstance();
